import Vue from 'vue'
import VueRouter from 'vue-router'
import { beforeEach } from './beforeEach'
import { afterEach } from './afterEach'

Vue.use(VueRouter)

const routes = [
  // =============================================================================
  // MAIN LAYOUT ROUTES
  // =============================================================================
  {
    path: '',
    component: () => import('../layouts/main/Main.vue'),
    meta: {requiresAuth: true},
    children: [
      {
        path: '/',
        name: 'home',
        component: () => import('../views/Home.vue')
      },
      {
        path: 'users',
        component: () => import('../views/users/index.vue'),
        children: [
          {
            path: '/',
            name: 'users',
            component: () => import(/* webpackChunkName: "usersList" */ '../views/users/list/UserList.vue'),
            meta: {
              permission: 'user.show',
              pageTitle: '',
              pageTitleI18n: 'users.list.title'
              // rule: 'editor'
            }
          },
          {
            path: 'trash',
            name: 'usersTrash',
            component: () => import(/* webpackChunkName: "usersTrash" */ '../views/users/trash/UserTrash.vue'),
            meta: {
              permission: 'user.delete',
              pageTitle: '',
              pageTitleI18n: 'users.trash.title'
              // rule: 'editor'
            }
          },
          {
            path: 'insert',
            name: 'insertUser',
            component: () => import(/* webpackChunkName: "insertUser" */ '../views/users/insert/InsertUser.vue'),
            meta: {
              permission: 'user.create',
              pageTitle: '',
              pageTitleI18n: 'users.insert.title'
              // rule: 'editor'
            }
          },
          {
            path: ':id',
            component: () => import('../views/users/user/index.vue'),
            children: [
              {
                path: '/',
                name: 'user',
                component: () => import(/* webpackChunkName: "user" */ '../views/users/user/profile/ProfileUser.vue'),
                meta: {
                  permission: 'user.show',
                  pageTitle: '',
                  pageTitleI18n: 'users.user.title',
                  layoutStatus: 'profile'
                  // rule: 'editor'
                }
              },
              {
                path: 'tasks',
                name: 'userTaskList',
                component: () => import(/* webpackChunkName: "userTaskList" */ '../views/tasks/list/TaskList.vue'),
                meta: {
                  permission: 'task.show',
                  pageTitle: '',
                  pageTitleI18n: 'tasks.list.title',
                  layoutStatus: 'profile'
                  // rule: 'editor'
                }
              },
              {
                path: 'tickets',
                name: 'userTicketsList',
                component: () => import(/* webpackChunkName: "userTicketsList" */ '../views/tickets/list/TicketList.vue'),
                meta: {
                  permission: 'ticket.show',
                  pageTitle: 'تیکت ها',
                  pageTitleI18n: 'tickets.list.title',
                  layoutStatus: 'profile'
                  // rule: 'editor'
                }
              }
            ]
          }
        ]
      },
      {
        path: 'tasks',
        component: () => import('../views/tasks/index.vue'),
        children: [
          {
            path: '/',
            name: 'taskList',
            component: () => import(/* webpackChunkName: "taskList" */ '../views/tasks/list/TaskList.vue'),
            meta: {
              permission: 'task.show',
              pageTitle: '',
              pageTitleI18n: 'tasks.list.title'
              // rule: 'editor'
            }
          }
        ]
      },
      {
        path: 'profile',
        component: () => import('../views/profile/index.vue'),
        children: [
          {
            path: '/',
            name: 'profile',
            component: () => import(/* webpackChunkName: "profile" */ '../views/profile/profile/ProfileUser.vue'),
            meta: {
              pageTitle: '',
              pageTitleI18n: 'profile.title',
              layoutStatus: 'profile'
              // rule: 'editor'
            }
          },
          {
            path: 'edit',
            name: 'editProfile',
            component: () => import(/* webpackChunkName: "editProfile" */ '../views/profile/edit/EditProfile.vue'),
            meta: {
              pageTitle: '',
              pageTitleI18n: 'profile.edit.title',
              layoutStatus: 'profile'
              // rule: 'editor'
            }
          },
          {
            path: 'tasks',
            name: 'profileTaskList',
            component: () => import(/* webpackChunkName: "profileTaskList" */ '../views/tasks/list/TaskList.vue'),
            meta: {
              permission: 'task.show',
              pageTitle: '',
              pageTitleI18n: 'tasks.list.title',
              layoutStatus: 'profile'
              // rule: 'editor'
            }
          },
          {
            path: 'tickets',
            name: 'profileTicketsList',
            component: () => import(/* webpackChunkName: "userTicketsList" */ '../views/tickets/list/TicketList.vue'),
            meta: {
              permission: 'ticket.show',
              pageTitle: 'تیکت ها',
              pageTitleI18n: 'tickets.list.title',
              layoutStatus: 'profile'
              // rule: 'editor'
            }
          }
        ]
      },
      {
        path: 'tickets',
        component: () => import('../views/tickets/index.vue'),
        children: [
          {
            path: '',
            name: 'tickets',
            component: () => import(/* webpackChunkName: "tickets" */ '../views/tickets/list/TicketList.vue'),
            meta: {
              permission: 'ticket.show-all',
              pageTitle: 'تیکت ها',
              pageTitleI18n: 'tickets.list.title'
              // rule: 'editor'
            }
          },
          {
            path: 'insert',
            name: 'insertTicket',
            component: () => import(/* webpackChunkName: "insertTicket" */ '../views/tickets/insert/InsertTicket.vue'),
            meta: {
              permission: 'ticket.create',
              pageTitle: 'افزودن تیکت جدید',
              pageTitleI18n: 'tickets.insert.title'
              // rule: 'editor'
            }
          },
          {
            path: ':id',
            name: 'ticketDetail',
            component: () => import(/* webpackChunkName: "ticketDetail" */ '../views/tickets/profile/TicketDetail.vue'),
            meta: {
              permission: 'ticket.show',
              pageTitle: '',
              pageTitleI18n: 'tickets.detail.title'
              // rule: 'editor'
            }
          }
        ]
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '*',
    name: 'PageNotFound',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/PageNotFound.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(beforeEach)
router.afterEach(afterEach)

export default router
